import { ddMMyyyy } from '@/utils/convert'
import { Badge } from '@surein/ui'
import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { FilterState } from './Filters'
import {
  StyledFiltersDisplay,
  StyledRelativeContainer,
  StyledXButton,
} from './styles'

type CurrentlyAppliedFiltersProps = {
  filters: FilterState
  onRemove: (key: keyof FilterState) => void
}

const CurrentlyAppliedFilters = ({
  filters,
  onRemove,
}: CurrentlyAppliedFiltersProps) => {
  const { t } = useTranslation()

  const hasDocs = filters.documentCategories.length > 0
  const hasInsurance = filters.insuranceCategories.length > 0

  return (
    <StyledFiltersDisplay>
      {hasDocs && (
        <Badge variant="success" size="lg">
          <StyledRelativeContainer>
            <span>{t('documentsPage.filters.category')}:</span>
            <span>{filters.documentCategories.length}</span>
            <StyledXButton
              variant="outline"
              size="sm"
              icon={X}
              onClick={() => onRemove('documentCategories')}
            />
          </StyledRelativeContainer>
        </Badge>
      )}

      {hasInsurance && (
        <Badge variant="success" size="lg">
          <StyledRelativeContainer>
            <span>{t('documentsPage.filters.insurance')}:</span>
            <span>{filters.insuranceCategories.length}</span>
            <StyledXButton
              variant="outline"
              size="sm"
              icon={X}
              onClick={() => onRemove('insuranceCategories')}
            />
          </StyledRelativeContainer>
        </Badge>
      )}

      {filters.date?.from && filters.date?.to && (
        <Badge variant="success" size="lg">
          <StyledRelativeContainer>
            <span>{t('documentsPage.filters.date')}:</span>
            <span>
              {ddMMyyyy(filters.date.from)} - {ddMMyyyy(filters.date.to)}
            </span>
            <StyledXButton
              variant="outline"
              size="sm"
              icon={X}
              onClick={() => onRemove('date')}
            />
          </StyledRelativeContainer>
        </Badge>
      )}
    </StyledFiltersDisplay>
  )
}

export default CurrentlyAppliedFilters
